<template>
    <div class="reports" :class="{loading:loading}">
        <fieldset>
            <legend class="no-margin">
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Reports
                    </div>

                    <div class="col-sm-6 col-md-5 form-group align-sm-left">
                        <button type="button" class="btn btn-success" @click="open(null)" :disabled="loading">
                            Schedule Report
                        </button>
                    </div>
                </div>
            </legend>

            <div class="form-group text-right">
                <div class="checkbox">
                    <label>
                        <input v-model="archived"
                               type="checkbox"
                               id="archived"
                               name="archived">
                        Show Archived
                    </label>
                </div>
            </div>

            <div class="list-group">
                <a v-bind:key="listReport.id" href="javascript://void(0)" class="list-group-item"
                   :class="{'list-group-item-success active':reportId === listReport.id}"
                   v-for="listReport in reports"
                   @click="open(listReport.id)">
                    <h5>
                        <div v-if="listReport.user">
                            {{listReport.user.fullName}} ({{listReport.user.email}})
                        </div>
                        <div v-else>
                            Unknown User
                        </div>
                        <span v-if="listReport.scheduleLabel"
                              v-html="listReport.scheduleLabel"></span>

                        <span v-if="listReport.archivedLabel"
                              v-html="listReport.archivedLabel"></span>
                    </h5>

                    <h6>{{listReport.displayName}}</h6>
                </a>
            </div>
        </fieldset>

        <report ref="report"
                :report-names="reportNames"
                :report-id="reportId"
                :user-id="userId"
                :reportable-id="reportableId"
                :reportable-type="reportableType"
                :afterSave="init">
            &nbsp;
        </report>
    </div>
</template>

<script>
    export default {
        props: {
            reportableId: {
                type: String,
                required: true
            },

            reportableType: {
                type: String,
                required: true,
                default: 'App\\Project'
            },

            reportNames: {
                type: Object,
                required: true,
            },

            userId: {
                type: String,
                default(){
                    return null;
                }
            }
        },

        created(){
            this.init();
        },

        data(){
            return {
                archived: false,
                loading: true,

                reports: [],
                reportId: null
            };
        },

        computed: {},

        watch: {
            archived(){
                this.init();
            }
        },

        filters: {},

        methods: {
            loadReports(){
                var url = '/api/reports?_load[]=user&reportable_type=' + this.reportableType + '&reportable_id=' + this.reportableId;

                if( this.userId ){
                    url += '&user_id=' + this.userId;
                }

                if( this.archived ){
                    url += '&archived=archived';
                }

                return axios.get( url )
                    .then( ( response ) => {
                        this.$set( this, 'reports', response.data.Reports );
                    } );
            },

            open( reportId ){
                this.reportId = reportId;

                this.$nextTick( () => {
                    this.$refs.report.openModal();
                } );
            },

            resetData(){
                Object.assign( this.$data, this.$options.data() );
            },

            afterSave(){
                this.resetData();

                this.$nextTick( () => {
                    this.loadReports()
                        .finally( () => {
                            this.loading = false;
                        } );
                } );
            },

            init(){
                this.loading = true;

                return this.loadReports()
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },
        }
    }
</script>
